import { Injectable } from "@angular/core";
import { AppStorageService } from '@shared/storage/app-storage.service';
import { tap } from 'rxjs/operators';

@Injectable()
export class PermissionCheckerService{
    constructor(storageService:AppStorageService){
        storageService.AllPermissionsSubject.pipe(tap(_=> console.debug("PermissionCheckerService-AllPermissionsSubject-bea28cb5-33a7-4f4c-867d-ad0a9c45eb48"))).subscribe(x=> this.allPermissions=x);
        storageService.GrantedPermissionsSubject.pipe(tap(_=> console.debug("PermissionCheckerService-GrantedPermissionsSubject-ba428809-bf22-4702-a9f7-d6bb57155f66"))).subscribe(x=> this.grantedPermissions=x);
    }
    allPermissions={};
    grantedPermissions={};
    isGranted(permissionName: any):boolean {
        /// TODO
       return this.allPermissions[permissionName] != undefined && this.grantedPermissions[permissionName] != undefined;
    }
}